import { DateUtils } from '@common/utils';
import dayjs from 'dayjs';
import React from 'react';
import { RiDownloadFill, RiEditFill, RiFile2Fill } from 'react-icons/ri';
import { MaybeAsync } from 'zod/v4/core/util';

export const FileItem = ({
                           title,
                           subType,
                           fileTitle,
                           editOptions,
                           downloadOptions,
                           dateModification,
                           fileBackgroundColor,
                           fileTextColor,
                         }: FileItemProps) => {
  return (
    <div className={'flex flex-col gap-2'}>

      {(title) && (
        <span className={'color-primary'}>{title}</span>
      )}

      <div className={'flex border border-2 rounded py-3 px-6 border-[#DDD]'}>

        <div className={'flex items-center gap-3'}>
          <RiFile2Fill className={'file-icon'} />
          <div className={`flex items-center justify-center rounded-full py-1 px-3 text-sm`}
               style={{ backgroundColor: fileBackgroundColor, color: fileTextColor || 'white' }}>
            <span>{subType}</span>
          </div>
        </div>

        <div className={'flex-1 flex justify-center'}>
          {fileTitle && (
            <span className={'text-sm text-[#333]'}>{fileTitle}</span>
          )}
        </div>

        <div className={'flex items-center gap-6'}>
          {dateModification && (
            <span className={'text-[#666666]'}>
                        {DateUtils.formatDdMmYyyy(dateModification)}
                    </span>
          )}
          {editOptions && (
            <RiEditFill className="file-view-icon"
                        onClick={() => editOptions!.fn()} />
          )}
          {downloadOptions && (
            <RiDownloadFill className={'file-view-icon'}
                            onClick={() => downloadOptions!.fn()} />
          )}
        </div>
      </div>
    </div>
  );
};

export interface FileItemProps {
  title?: string;
  subType: string;
  fileTitle?: string;
  downloadUrl?: string;
  editOptions?: DownloadOptions;
  downloadOptions?: DownloadOptions;
  dateModification?: dayjs.ConfigType;
  fileBackgroundColor: string;
  fileTextColor?: string;
}

interface DownloadOptions {
  fn: () => MaybeAsync<void>;
  disabled?: boolean;
}